import React from "react";
import { Navbar, Container, Nav, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDoorOpen } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import logo from "assets/logo.png";
import { useNavbarStore } from "../../zustand/navbarStore";
import { useAuthStore } from "../../zustand/loginStore";

const CustomNavbar: React.FC = () => {
  const navigate = useNavigate();
  const { selectedNav, setSelectedNav } = useNavbarStore();
  const { setToken } = useAuthStore();
  const navItems = [
    "tablero",
    "inventarios",
    "promociones",
    "pedidos",
    "usuarios",
    "reportes",
    "pagos"
  ];
  return (
    <Navbar className="bg-custom-yellow" style={{ padding: 0 }} expand="lg">
      <Container fluid style={{ height: "60px" }}>
        <Navbar.Brand className="ms-3">
          <img
            src={logo}
            alt="Logo de la Boutique"
            style={{ width: "50px" }}
            onClick={() => navigate("/dashboard")}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" style={{ height: "100%" }}>
          <Nav
            className="mx-auto"
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              paddingLeft: "10%",
            }}
          >
            {navItems.map((item, index) => (
              <React.Fragment key={item}>
                {index > 0 && (
                  <div
                    style={{
                      width: "2px",
                      backgroundColor: "rgba(255, 255, 255, 0.7)",
                      margin: "10px 0",
                      alignSelf: "center",
                      height: "60%",
                      display:
                        selectedNav === item ||
                        selectedNav === navItems[index - 1]
                          ? "none"
                          : "block",
                    }}
                  />
                )}
                <Nav.Link
                  onClick={() => {
                    setSelectedNav(item);
                    navigate(`/dashboard#${item}`);
                  }}
                  style={{
                    backgroundColor:
                      selectedNav === item ? "white" : "transparent",
                    height: "100%",
                    fontWeight: 800,
                    fontSize: "1.1rem",
                    display: "flex",
                    alignItems: "center",
                    padding: "0 25px",
                    margin: "0 5px",
                    color: "black",
                  }}
                >
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </Nav.Link>
              </React.Fragment>
            ))}
          </Nav>
          <Button
            variant="link"
            className="ms-auto me-3"
            style={{
              textDecoration: "none",
              color: "black",
              fontWeight: 800,
              fontSize: "1.1rem",
            }}
            onClick={() => {
              navigate("/adminLogin");
              setToken(null);
            }}
          >
            <FontAwesomeIcon
              icon={faDoorOpen}
              className="me-2"
              style={{ height: "1.4rem" }}
            />
            Salir
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
